export default {
      id: "ciel-voile-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#ciel-voile-usage",
      toString: function () {
        return this.url;
      }
    }